require('./boot/prototype-array-boot')
require('./boot/prototype-object-boot')
require('./boot/vue-boot')